// /**
//  * driver - Add
//  */

// React
import React, {useEffect, useState} from 'react';
import FileDownload from 'js-file-download';

// react hook form
import {useForm} from 'react-hook-form';

// UI
import theme from '../../../theme';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import {
  Button,
  Grid,
  IconButton,
  Paper,
  Tab,
  Tabs,
  TextField,
  Typography,
} from '@material-ui/core';
import jMoment from 'moment-jalaali';

// Icon
import Icon from '@mdi/react';
import {
  mdiArrowRight,
  mdiCarMultiple,
  mdiCheck,
  mdiChevronDoubleDown,
  mdiChevronDoubleUp,
  mdiClose,
  mdiCommentQuestion,
  mdiCreditCard,
  mdiCreditCardCheckOutline,
  mdiCreditCardMultipleOutline,
  mdiCreditCardOff,
  mdiCurrencyUsd,
  mdiPaperclip,
  mdiText,
  mdiUpload,
} from '@mdi/js';

// Type
import {SelectorProps} from './interfaces';

// helpers'
import {flattenObject, removeEmptyValueObject} from '../../../utils/helpers';
import {
  addWalletDriversBulkTransactionAction,
  addWalletDriversTransactionAction,
  getDriversWalletAction,
} from '../../drivers/actions';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {createStructuredSelector} from 'reselect';
import {Store} from '../../../redux/reducers';
import {
  makeSelectDriversWalletBulkTransaction,
  makeSelectDriversWalletBulkTransactionResult,
  makeSelectDriversWalletList,
  makeSelectError,
  makeSelectLoading,
} from '../../drivers/selectors';

import {Link, useHistory} from 'react-router-dom';
import {Payload} from '../../drivers/interfaces';

import {CSVLink} from 'react-csv';

jMoment.loadPersian({dialect: 'persian-modern', usePersianDigits: true});

type Props = {
  match: {
    params: {
      id: number;
    };
  };
  driversWalletResult: {
    totalitems: number;
    successitems: number;
    faileditems: number;
  };
  driversWalletResponse: '';
  driversWalletList: [];
  walletTransactionDispatch: (payload: Payload) => void;
  driversDispatch: (payload: Payload) => void;
};

type Inputs = {
  description: string;
  reason: string;
  amount: number;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      '& .MuiFormControl-marginNormal': {
        marginTop: 0,
      },
    },
    '.margin-date-0': {
      '&.MuiFormControl-marginNormal': {
        marginTop: 0,
      },
    },
    type: {
      flexGrow: 1,
      maxWidth: 500,
    },
    paper: {
      marginTop: '36px',
      width: '100%',
      marginBottom: '36px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
      '@media (max-width: 768px)': {
        padding: theme.spacing(0),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
      },
    },
    // Cancel Dialog
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),

      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.success.main,
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'center',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '28px',
    },
    margin: {
      // margin: theme.spacing(1),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textInput: {
      width: '60%',
      '& input, .MuiSelect-root': {
        padding: '12px 10px 12px !important',
      },

      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
    },

    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontWeight: 500,
      width: '100%',
      '& > *': {
        // margin: theme.spacing(0, 0, 0, 1),
      },
    },
    icon: {
      color: '#8a8a8a',
      marginRight: theme.spacing(1),
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8a8a8a',
      marginRight: '8px',
    },
    addIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.green.main,
      },
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  })
);

function Index(props: Props) {
  const classes = useStyles();
  const [file, setFile] = useState<any>('');
  const [fileData, setFileData] = useState<any>('');
  const [fileName, setFileName] = useState<any>('');
  const [fileChange, setFileChange] = useState(false);
  const dataCsv = [
    ['amount', 'driverId', 'reason', 'phoneNumber', 'description'],
    [245000, 4, 'charge', '+989121456677', 'test 1'],
    [30000, 6, 'salary', '+989121457788', 'test 2'],
    [40000, 9, 'salary + gift', '+989121453399', 'test 3'],
  ];
  const {register, handleSubmit, errors, watch, setValue, getValues} = useForm<
    Inputs
  >({
    defaultValues: {
      employmentStartDate: null,
      birthDate: null,
    },
  });

  const onSubmit = (data: Inputs) => {
    const inputData = new FormData();
    inputData.append('file', fileData);
    handleCreateParcel(inputData);
  };

  const handleCreateParcel = (transactionDate: any) => {
    props.walletTransactionDispatch({
      body: transactionDate,
      callback: () => {
        setFileChange(!fileChange);
        setFile('');
        setFileData('');
        setFileName('');
      },
    });
  };

  const handleChangeFileInput = (event: any) => {
    setFileData(event.target.files[0]);
    setFileName(event.target.files[0].name);
  };

  useEffect(() => {
    if (props.driversWalletResponse.length) {
      FileDownload(
        new Blob([props.driversWalletResponse]),
        'report.xls',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      );
    }
  }, [fileChange]);

  return (
    <>
      <div className={classes.headerBox}>
        <Typography variant="h6" component="h2">
          {`
        شارژ دسته جمعی کیف پول 
        `}
        </Typography>
      </div>

      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Button
          aria-label="details"
          size="medium"
          onClick={() => window.history.back()}
        >
          <Icon path={mdiArrowRight} size={1} className={classes.icon} />
          {'بازگشت'}
        </Button>
        <Grid
          style={{
            backgroundColor: 'white',
            padding: '5px',
            borderRadius: '5px',
          }}
          container
          item
          xs={4}
          justify="flex-end"
          alignItems="center"
          spacing={3}
        >
          <Link
            to="/SampleDriversWallet.xlsx"
            download
            style={{
              backgroundColor: theme.palette.primary.main,
              padding: '5px 10px',
              color: '#fff',
              marginLeft: '15px',
              textDecoration: 'none',
              borderRadius: '5px',
            }}
            target="_blank"
          >
            {'دانلود فایل نمونه'}
          </Link>
          <TextField
            id="amount"
            name="amount"
            variant="outlined"
            className={classes.textInput}
            value={fileName}
            disabled
          />
          <IconButton component="label" title="آپلود فایل">
            <Icon
              color={theme.palette.secondary.main}
              path={mdiPaperclip}
              size={1}
            />
            <input
              type="file"
              name="file"
              value={file}
              onChange={handleChangeFileInput}
              hidden
            />
          </IconButton>
        </Grid>
      </Grid>
      <Grid container>
        <Paper
          style={{width: '50%'}}
          elevation={3}
          className={classes.paper}
          variant="elevation"
          square
        >
          <div className={classes.item}>
            <span style={{paddingLeft: '50px'}}>{'شرایط و قواعد فایل :'}</span>
            <Grid item xs={6}>
              <span>{''}</span>
            </Grid>
          </div>
        </Paper>
      </Grid>
      <form style={{display: 'flex'}} onSubmit={handleSubmit(onSubmit)}>
        <Grid container style={{margin: 0}} alignItems="flex-start">
          <Grid item container xs={12} justify="flex-end">
            <Grid item>
              <Button
                type="submit"
                fullWidth
                size="large"
                data-cy="search"
                variant="contained"
                color="secondary"
                disabled={!fileData}
              >
                {'شارژ کیف های پول'}
              </Button>
            </Grid>
          </Grid>
          {props.driversWalletResult?.faileditems && (
            <Paper
              elevation={3}
              className={classes.paper}
              variant="elevation"
              square
            >
              <div style={{marginTop: '-66px'}} className={classes.addIcon}>
                <Icon
                  path={mdiCreditCardMultipleOutline}
                  size={4}
                  color={theme.palette.green.main}
                />
              </div>
              <Grid
                style={{padding: '30px 20px', marginTop: '10px'}}
                container
                spacing={2}
                alignItems="flex-start"
              >
                <Grid container item xs={6} sm={6} md={4} alignItems="center">
                  <div className={classes.item}>
                    <span className={classes.label}>
                      <Icon
                        path={mdiCarMultiple}
                        size={1}
                        className={classes.icon}
                        color={theme.palette.secondary.main}
                      />
                    </span>

                    <span style={{width: '100%'}}>{'تعداد کل راننده ها'}</span>
                  </div>
                </Grid>
                <Grid container item xs={6} sm={6} md={4} alignItems="flex-end">
                  <div className={classes.item}>
                    <span className={classes.label}>
                      <Icon
                        path={mdiCreditCardOff}
                        size={1}
                        color={theme.palette.error.main}
                        className={classes.icon}
                      />
                    </span>

                    <span style={{width: '100%'}}>{'تعداد شارژ با خطا'}</span>
                  </div>
                </Grid>
                <Grid container item xs={6} sm={6} md={4} alignItems="flex-end">
                  <div className={classes.item}>
                    <span className={classes.label}>
                      <Icon
                        path={mdiCreditCardCheckOutline}
                        size={1}
                        color={theme.palette.green.main}
                        className={classes.icon}
                      />
                    </span>

                    <span style={{width: '100%'}}>{'تعداد شارژ بدون خطا'}</span>
                  </div>
                </Grid>
                <Grid container item xs={6} sm={6} md={4} alignItems="center">
                  <div className={classes.item}>
                    <span className={classes.label}></span>

                    <span
                      style={{
                        width: '100%',
                        padding: '0 40px',
                        color: theme.palette.secondary.main,
                      }}
                    >
                      {props.driversWalletResult.totalitems}
                    </span>
                  </div>
                </Grid>
                <Grid container item xs={6} sm={6} md={4} alignItems="center">
                  <div className={classes.item}>
                    <span className={classes.label}></span>

                    <span
                      style={{
                        width: '100%',
                        padding: '0 40px',
                        color: theme.palette.error.main,
                      }}
                    >
                      {props.driversWalletResult.faileditems}
                    </span>
                  </div>
                </Grid>
                <Grid container item xs={6} sm={6} md={4} alignItems="center">
                  <div className={classes.item}>
                    <span className={classes.label}></span>

                    <span
                      style={{
                        width: '100%',
                        padding: '0 40px',
                        color: theme.palette.green.main,
                      }}
                    >
                      {props.driversWalletResult.successitems}
                    </span>
                  </div>
                </Grid>
                <Grid
                  style={{marginTop: '30px'}}
                  container
                  item
                  xs={12}
                  alignItems="flex-end"
                >
                  <div className={classes.item}>
                    <span className={classes.label}>
                      <Icon
                        path={mdiText}
                        size={1}
                        className={classes.icon}
                        color={theme.palette.primary.main}
                      />
                    </span>

                    <span style={{width: '100%'}}>{'توضیحات'}</span>
                  </div>
                </Grid>
              </Grid>
            </Paper>
          )}
        </Grid>
      </form>
    </>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  driversWalletList: makeSelectDriversWalletList(),
  driversWalletResponse: makeSelectDriversWalletBulkTransaction(),
  driversWalletResult: makeSelectDriversWalletBulkTransactionResult(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    driversDispatch: (payload: Payload) =>
      dispatch(getDriversWalletAction(payload)),
    walletTransactionDispatch: (payload: Payload) =>
      dispatch(addWalletDriversBulkTransactionAction(payload)),
  };
}
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Index);
